import { DetailSection, LwButton } from 'redesign';
import { useTranslation } from 'react-i18next';
import { routes } from 'ogp/Routes';
import { IconEdit } from 'assets/img';
import { useCompanyRelativePath } from 'ogp/hooks';
import { Box } from '@mui/material';
import { useSettingsDetailTheme } from './use-settings-detail-theme';

export const SettingsDetailTheme = () => {
  const { t } = useTranslation('ogp-screen-specific');
  const generatePath = useCompanyRelativePath();
  const columns = useSettingsDetailTheme();

  return (
    <Box mb={4} gap={2} display="flex" flexDirection="column">
      <Box mb={4} display="flex" gap={2}>
        <LwButton
          to={generatePath(routes.SettingsEditTheme)}
          startIcon={<IconEdit />}
          color="primary"
          iconColorMode="fill"
        >
          {t('settings-detail.edit-button')}
        </LwButton>
      </Box>
      <DetailSection columns={columns} />
    </Box>
  );
};
